import { useEffect, useState } from "react";
import MultiSelectPropsType from "../../Types/MultiSelectPropsType";

const StyledMultiSelect = ({
  text,
  placeholder,
  optionList,
  list,
  className = "styledInput",
}: MultiSelectPropsType) => {
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [selectedList, setSelectedList] = useState<
    | { course_name: string; test_name: string; chosen?: boolean }[]
    | Record<string, any>[]
  >([]);

  useEffect(() => {
    let list = optionList.map((item) => ({
      ...item,
      chosen: false,
    }));

    setSelectedList(list);
  }, [optionList]);

  useEffect(() => {
    list(selectedList);
  }, [selectedList]);

  function onItemClick(e: string) {
    const list = selectedList.map((item) => {
      if (item.test_name === e) {
        if (item.chosen) {
          setCount(count - 1);
          return { ...item, chosen: false };
        } else {
          setCount(count + 1);
          return { ...item, chosen: true };
        }
      } else {
        return item;
      }
    });
    setSelectedList(list);
  }

  function onOpen() {
    open ? setOpen(false) : setOpen(true);
  }

  window.addEventListener("click", (e) => {
    const target: any = e.target;
    if (
      !target.closest(".styledSelectList") &&
      !target.closest(".styledSelectButton") &&
      !target.closest(".styledSelectHead")
    ) {
      setOpen(false);
    } else if (
      open &&
      target.closest(".styledSelectButton") &&
      target.closest(".styledSelectHead")
    ) {
      setOpen(false);
    } else if (target.closest(".styledSelectList")) {
      setOpen(true);
    }
  });

  return (
    <div>
      {" "}
      <div
        className={className}
        style={open ? { border: "solid 2px black" } : {}}
        onClick={onOpen}
      >
        <div className="styledSelectHead">{text}</div>
        <div className="styledSelectButton">
          {count > 0 ? `Выбрано: ${count}` : placeholder}
        </div>
      </div>
      {open && (
        <div className="styledSelectList">
          {open &&
            selectedList.map((item, index) => {
              return (
                <div
                  className={item.chosen ? "styledSelectedItem" : ""}
                  key={index}
                  onClick={() => onItemClick(item.test_name)}
                >
                  {item.test_name}
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
};

export default StyledMultiSelect;
